import * as React from 'react';

const FilterIcon = (props) => (
    <svg width={12} height={12} xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M9 5a.21.21 0 0 1-.21.21H5.21v3.58a.21.21 0 0 1-.42 0V5.21H1.21a.233.233 0 0 1-.15-.06.219.219 0 0 1 0-.3.233.233 0 0 1 .15-.06h3.58V1.21a.21.21 0 0 1 .42 0v3.58h3.58A.21.21 0 0 1 9 5z"
            fill="#1D1D1B"
            stroke="#000"
            strokeWidth={0.2}
        />
    </svg>
);

export default FilterIcon;
